<template>
  <div>
    <ProgressBar active-step="Welcome back" />
    <PageHeading
      id="welcomeBackPageHeading"
      :default-heading="pageHeader"
    />
    <form
      novalidate="novalidate"
      @submit.prevent
    >
      <div
        class="pvd-container container-divider"
      >
        <h2
          id="welcomeBackInfo"
          class="pvd-heading-L"
        >
          {{ pd_content.welcome_back_info_header }}
        </h2>
        <p
          id="welcomeBackDisclosure"
        >
          {{ pd_content.welcome_back_login_header }}
        </p>
      </div>
      <!-- Reset password Button -->
      <div class="pvd-container pvd-btn-row">
        <div class="button-group">
          <button
            id="resetPasswordButton"
            type="button"
            class="pvd-btn btn-secondary"
            @click.prevent="handleResetPasswordClick
              (pd_content.welcome_back_reset_password_button)"
          >
            {{ resetPasswordButtonText }}
          </button>
          <!-- login  button -->
          <button
            id="logInButton"
            type="button"
            class="pvd-btn btn-secondary"
            @click.prevent="handleLoginClick
              (pd_content.welcome_back_login_button)"
          >
            {{ logInButtonText }}
          </button>
        </div>
        <!-- Exit link -->
        <div class="tertiary-link xsmall">
          <a
            :href="pd_content.welcome_back_exit_link.url"
            @click="handleWelcomeBackExitClick"
          >
            {{ pd_content.welcome_back_exit_link.value }}</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import utility from '../mixins/utility';
import validationHelper from '../mixins/validationHelper';
import measurement from '../mixins/measurement';
import constants from '../mixins/constants';

export default {
  name: 'WelcomeBack',
  components: {
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, utility, validationHelper, measurement],
  inject: ['$validator'],
  data() {
    return {
      knowYourLogin: '',
      backButtonAttempt: false,
    };
  },
  computed: {
    pageHeader() {
      return this.pd_content.welcome_back_page_header || constants.WELCOME_BACK_PAGE_HEADER;
    },
    logInButtonText() {
      const buttonText = this.pd_content.welcome_back_login_button.value;
      return buttonText;
    },
    resetPasswordButtonText() {
      const buttonText = this.pd_content.welcome_back_reset_password_button.value;
      return buttonText;
    },
  },
  mounted() {
    this.track(this.cs_stateName, 'pageview');
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
  },
  methods: {
    handleLoginClick() {
      this.track('login_button', 'interaction');
      document.title = this.setTitle(this.pageHeader);

      // Build dynamic redirect URL based on current route to preserve Trust AO context
      const currentOrigin = window.location.origin;
      const currentPath = window.location.pathname;

      // Extract base login URL (remove any existing query params)
      const baseLoginUrl = this.pd_envConfig.welcomeBackloginURL.split('?')[0];

      // For trust and other routes, redirect back to the main route page after authentication
      // The server will detect the authenticated user and resume the appropriate flow
      let returnUrl;
      if (this.routeId === 'trust') {
        returnUrl = `${currentOrigin}${currentPath}#/trust-login`;
      } else {
        // For other routes, use a similar pattern or the current path
        returnUrl = `${currentOrigin}${currentPath}`;
      }

      const loginUrl = `${baseLoginUrl}?AuthRedUrl=${encodeURIComponent(returnUrl)}`;

      window.location.assign(loginUrl);
    },
    handleResetPasswordClick() {
      this.track('reset_password', 'interaction');
      window.location.assign(this.pd_envConfig.resetPasswordURL);
    },
    handleWelcomeBackExitClick() {
      this.track('welcome-back-exit-link', 'interaction');
    },
  },
};
</script>

<style scoped>
</style>
